import SavedProductsPreview from './SavedProductsPreview'

export default SavedProductsPreview